import React, { FC } from 'react';

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
    hint?: string;
};

export const ValidationInput: FC<InputProps> = ({
    type,
    placeholder,
    hint,
    required,
    onChange,
    value,
    ...rest
}) => (
    <>
        <input
            type={type}
            placeholder={placeholder}
            required={required}
            value={value}
            onInvalid={e => {
                const input = e.target as HTMLInputElement;
                if (required && value === '') {
                    input.setCustomValidity(`${placeholder} required`);
                } else if (hint) {
                    input.setCustomValidity(hint);
                }
            }}
            onChange={e => {
                e.target.setCustomValidity('');
                if (onChange) return onChange(e);
            }}
            {...rest}
        />
        <span className="c-invalid">*</span>
    </>
);

export const LabeledValidationInput: FC<InputProps> = ({
    placeholder,
    ...rest
}) => (
    <>
        <label className="c-invisible-label">
            <div>{placeholder}</div>
            <ValidationInput placeholder={placeholder} {...rest} />
        </label>
    </>
);
